module.exports = __webpack_public_path__ + "static/media/productTypeCar.f22580bb.svg";